import styled from 'styled-components';

const Container = styled.div<{ fontSize: number }>`
	margin: 0 20px
	font-size: ${({ fontSize }) => fontSize}%;
	font-weight: bold;
	display: flex;
	background: white;
	justify-content: flex-end;
	z-index: 1;
`;

const Item = styled.div`
    align-items: center;
    display: flex;
    margin: 5px 10px;
`;

const Dot = styled.div<{ backgroundColor: string }>`
    background-color: ${({ backgroundColor }) => backgroundColor};
    border-radius: 3px;
    border: 1px solid #333;
    margin-right: 3px;
    height: 15px;
    width: 15px;
`;

export { Container, Dot, Item };
